import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import voca from 'voca';
import { createStructuredSelector } from 'reselect';
import appConfig from 'appConfig';
import { selectPalette, selectFonts } from 'root/selectors';
import { getTextColorByBackgroundColor } from 'utils/colorUtils';

const createPaletteCss = (palette) =>
  Object.keys(palette).reduce((css, name) => {
    const color = palette[name];
    const prefix = voca.kebabCase(name);
    const textColor = getTextColorByBackgroundColor(color, palette.textLight, palette.textDark);

    return `
                ${css}

                .bg-${prefix},
                .bg-${prefix}-hover:hover {
                    background-color: ${color};
                }

                /* -- */

                .bg-${prefix}-c,
                .bg-${prefix}-c > a,
                a.bg-${prefix}-c {
                    color: ${textColor};
                }

                .bg-${prefix}-fill,
                .fill-bg-${prefix} {
                    fill: ${textColor};
                }

                /* -- */
                .c-${prefix},
                .c-${prefix} > a,
                a.c-${prefix},
                .c-${prefix}-hover:hover {
                    color: ${color};
                }

                /* -- */

                .bc-${prefix} {
                    border-color: ${color};
                }

                .fill-${prefix},
                .fill-${prefix} path,
                .fill-${prefix}-hover:hover path {
                    fill: ${color};
                }
                .bg-${prefix}-fill,
                .fill-bg-${prefix} {
                    fill: ${textColor};
                }

                /* -- */
                .c-${prefix},
                .c-${prefix} > a,
                a.c-${prefix},
                .c-${prefix}-hover:hover {
                    color: ${color};
                }

                .c-${prefix}-bg {
                    background-color: ${textColor};
                }

                /* -- */

                .bc-${prefix} {
                    border-color: ${color};
                }

                .fill-${prefix},
                .fill-${prefix} path,
                .fill-${prefix}-hover:hover path {
                    fill: ${color};
                }

                .fill-${prefix}-c {
                    fill: ${textColor};
                }

                .circle-${prefix} circle {
                    stroke: ${color};
                }
            `;
  }, '');

const createFontsCss = (fonts) => {
  let fontFamily = fonts && fonts.fontFamily;

  if (!fontFamily || fontFamily.toLowerCase() === 'default') {
    fontFamily = appConfig.customization.defaultFontFamily;
  }

  return `.font-root {
        font-family: ${fontFamily};
    }`;
};

const renderFontLink = (url) => <link href={url} rel="stylesheet" key={url} />;

const createStylesCss = ({ palette, fonts }) => {
  const paletteCss = createPaletteCss(palette);
  const fontsCss = createFontsCss(fonts);

  return `
        ${fontsCss}
        ${paletteCss}`;
};

export const Styles = ({ palette, fonts }) => {
  const stylesCss = createStylesCss({ palette, fonts });
  const containerEl = document.getElementsByTagName('head')[0];

  return ReactDOM.createPortal(
    <>
      {fonts && fonts.links.map(renderFontLink)}

      <style type="text/css" data-customization="palette,font">
        {stylesCss}
      </style>
    </>,
    containerEl
  );
};

export default connect(
  createStructuredSelector({
    palette: selectPalette,
    fonts: selectFonts,
  })
)(Styles);
